const holders = new Set();
let writeStore;
let sendOutbox;
let listening = false;
const attempt = (fn) => {
    if (!fn)
        return;
    try {
        fn();
    }
    catch (error) {
        console.error('jaen: a flush on the way out of the page failed', error);
    }
};
export const flushOnLeave = () => {
    for (const holder of Array.from(holders))
        attempt(holder);
    attempt(writeStore);
    attempt(sendOutbox);
};
const onVisibilityChange = () => {
    if (typeof document === 'undefined' ||
        document.visibilityState === 'hidden') {
        flushOnLeave();
    }
};
const listen = () => {
    if (listening)
        return;
    listening = true;
    if (typeof document !== 'undefined') {
        document.addEventListener('visibilitychange', onVisibilityChange);
    }
    if (typeof window !== 'undefined') {
        window.addEventListener('pagehide', flushOnLeave);
    }
};
export const registerLeaveFlush = (flush) => {
    listen();
    holders.add(flush);
    return () => {
        holders.delete(flush);
    };
};
export const setLeaveStoreFlush = (flush) => {
    listen();
    writeStore = flush;
};
export const setLeaveOutboxFlush = (flush) => {
    sendOutbox = flush;
};
